import React from 'react';
import { Link } from 'react-router-dom';
import { usePageMeta } from '../../hooks/usePageMeta';
import { PageHero } from '../../components/ui/PageHero';
import { ActionLink } from '../../components/ui/ActionLink';
import { TextLink } from '../../components/ui/TextLink';
import { MockupTag } from '../../components/ui/MockupTag';
import { EnquirySection } from '../../components/forms/EnquirySection';
import { NotFound } from '../NotFound';
import { policies } from '../../data/policies';
export function PolicyPage({
  slug
}: {
  slug: string;
}) {
  const policy = policies.find(item => item.slug === slug);
  usePageMeta(policy?.metaTitle ?? 'Policy not found | ES World', policy?.metaDescription ?? 'This page does not exist.');
  if (!policy) return <NotFound data-id="element-1358" data-mp="2a1lmsa0t4x8f" />;
  return <>
      <PageHero breadcrumbs={[{
      label: policy.name,
      to: `/${policy.slug}`
    }]} title={policy.h1} lead={policy.lead} primary={{
      label: 'Ask us about this policy',
      to: '#enquire'
    }} secondary={{
      label: 'Browse all policies',
      to: '#policy-list'
    }} data-id="element-1359" data-mp="46142itx6tsx" />

      <div className="w-full bg-white" data-id="element-1360" data-mp="3rwajcyhswm1s">
        <div className="mx-auto grid max-w-content gap-12 px-5 py-16 md:px-8 md:py-24 lg:grid-cols-12" data-id="element-1361" data-mp="3rv96qpl4zrhy">
          <aside className="lg:col-span-3" id="policy-list" aria-label="Policies" data-id="element-1362" data-mp="aeztdk4ki750">
            <div className="lg:sticky lg:top-28" data-id="element-1363" data-mp="5hr83ao4hmzj">
              <p className="type-label text-muted" data-id="element-1364" data-mp="3dw9mdu4npyrl">Policies</p>
              <ul className="mt-3 space-y-1" data-id="element-1365" data-mp="3dwroh7e0377f">
                {policies.map(item => {
                const active = item.slug === policy.slug;
                return <li key={item.slug} data-id="element-1366" data-mp="3nvgvg54cz78w">
                      <Link to={`/${item.slug}`} aria-current={active ? 'page' : undefined} className={`block border-l-2 py-1.5 pl-3 type-card-desc transition-colors duration-150 ${active ? 'border-brand font-bold text-ink' : 'border-line text-body hover:text-ink'}`} data-id="element-1367" data-mp="3ns2un1bcf63k">
                        {item.name}
                      </Link>
                    </li>;
              })}
              </ul>
            </div>
          </aside>
          <div className="max-w-[720px] lg:col-span-9" data-id="element-1368" data-mp="1f4erj8xe77hl">
            <MockupTag note="Sample policy text — legal review needed" className="mb-8" data-id="element-1369" data-mp="1k4j9z4hv2cag" />
            {policy.sections.map(section => <section key={section.title} className="mb-12" data-id="element-1370" data-mp="mfppn7oiiy4s">
                <h2 className="type-h2 text-ink" data-id="element-1371" data-mp="rhyhg0pnfu5b">{section.title}</h2>
                {section.paragraphs.map(paragraph => <p key={paragraph} className="mt-4 type-body" data-id="element-1372" data-mp="weozuuoxf1tw">
                    {paragraph}
                  </p>)}
              </section>)}
            <div className="flex flex-col items-start gap-4 border-t border-line pt-8 sm:flex-row sm:items-center" data-id="element-1373" data-mp="3qjd62ebb2rf">
              <ActionLink to="/contact" data-id="element-1374" data-mp="8okw8nbqn22w">Contact our team</ActionLink>
              <TextLink to="/price-list/dubai" data-id="element-1375" data-mp="2lznpf5hd8qpt">View our price lists</TextLink>
            </div>
          </div>
        </div>
      </div>

      <EnquirySection title="Questions about this policy?" description="Write to us if something is not clear. Our team explains the rules in simple words." submitLabel="Send my policy question" showCourseFields={false} data-id="element-1376" data-mp="2hzvb0c5ajqcj" />
    </>;
}